import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase/firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';
import './AddonPricingModal.css';

const AddonPricingModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [addonPricing, setAddonPricing] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch addon pricing from Firestore plans collection
  useEffect(() => {
    if (!isOpen || addonPricing) return;

    const fetchAddonPricing = async () => {
      try {
        setLoading(true);
        const addonDoc = await getDoc(doc(db, 'plans', 'singleDownloadAddon'));
        if (addonDoc.exists()) {
          const data = addonDoc.data();
          setAddonPricing({
            initialPrice: data.initialPrice || data.initial_price || null,
            actualPrice: data.actualPrice || data.actual_price || null,
            currency: data.currency || 'INR',
            name: data.planName || data.name || 'Single Template Download',
            description: data.description || 'Download 1 additional resume template',
          });
        } else {
          // Fallback if addon doc doesn't exist
          setAddonPricing({
            initialPrice: '29.99',
            actualPrice: '19.99',
            currency: 'INR',
            name: 'Single Template Download',
            description: 'Download 1 additional resume template',
          });
        }
      } catch (error) {
        console.error('Error fetching addon pricing:', error);
        setAddonPricing({
          initialPrice: '29.99',
          actualPrice: '19.99',
          currency: 'INR',
          name: 'Single Template Download',
          description: 'Download 1 additional resume template',
        });
      } finally {
        setLoading(false);
      }
    };

    fetchAddonPricing();
  }, [isOpen, addonPricing]);

  if (!isOpen) return null;

  return (
    <div className="addon-modal-overlay" onClick={onClose}>
      <div className="addon-modal" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button className="addon-modal-close" onClick={onClose}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        {/* Limit Exceeded Message */}
        <div className="addon-header">
          <div className="addon-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          </div>
          <h3 className="addon-title">Download Limit Reached</h3>
          <p className="addon-subtitle">You've used all your available resume downloads on your Silver plan.</p>
        </div>

        {/* Addon Pricing Card */}
        <div className="addon-card">
          <div className="addon-card-badge">Add-On</div>
          <h4 className="addon-card-name">
            {loading ? 'Loading...' : (addonPricing?.name || 'Single Template Download')}
          </h4>
          <p className="addon-card-desc">
            {addonPricing?.description || 'Download 1 additional resume template'}
          </p>

          {loading ? (
            <div className="addon-price-loading">
              <div className="addon-shimmer"></div>
            </div>
          ) : addonPricing ? (
            <div className="addon-price-display">
              {addonPricing.initialPrice && addonPricing.actualPrice &&
               String(addonPricing.initialPrice) !== String(addonPricing.actualPrice) ? (
                <>
                  <div className="addon-original-price">
                    <span className="addon-currency">₹</span>
                    <span className="addon-price-amount">{addonPricing.initialPrice}</span>
                  </div>
                  <div className="addon-current-price">
                    <span className="addon-currency">₹</span>
                    <span className="addon-price-amount">{addonPricing.actualPrice}</span>
                  </div>
                </>
              ) : (
                <div className="addon-current-price">
                  <span className="addon-currency">₹</span>
                  <span className="addon-price-amount">{addonPricing.actualPrice || addonPricing.initialPrice}</span>
                </div>
              )}
            </div>
          ) : null}

          <button className="addon-buy-btn" disabled>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2L4 6v6c0 5.5 3.8 10.7 8 12 4.2-1.3 8-6.5 8-12V6l-8-4z"/>
            </svg>
            Buy Add-On (Coming Soon)
          </button>
        </div>

        {/* Check Other Plans */}
        <div className="addon-footer">
          <p className="addon-footer-text">Looking for more downloads and premium features?</p>
          <button
            className="addon-plans-btn"
            onClick={() => { onClose(); navigate('/pricing'); }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            Check Other Premium Plans
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddonPricingModal;
